export function createAction(action) {
    return action;
}
